(() => {
  function init(root = document) {
    const checkbox = root.querySelector('[data-cart-acceptance-checkbox]');
    const buttons = root.querySelectorAll('[data-cart-checkout-button]');

    if (!checkbox || !buttons.length) return;

    const sync = () => {
      const accepted = checkbox.checked;

      buttons.forEach((btn) => {
        const disabledByCart = btn.hasAttribute('data-disabled-by-cart') || btn.disabled && btn.form === null;

        const mustStayDisabled = btn.getAttribute('data-cart-empty') === 'true';
        btn.disabled = mustStayDisabled ? true : !accepted;
        btn.setAttribute('aria-disabled', String(btn.disabled));
      });
    };

    checkbox.addEventListener('change', sync);
    sync();
  }

  document.addEventListener('DOMContentLoaded', () => init());

  const mo = new MutationObserver(() => init());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
